/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  FieldPermissionResponse,
  PermissionMetadataResponse,
  PermissionSetResponse,
} from '../models/index';
import {
    FieldPermissionResponseFromJSON,
    FieldPermissionResponseToJSON,
    PermissionMetadataResponseFromJSON,
    PermissionMetadataResponseToJSON,
    PermissionSetResponseFromJSON,
    PermissionSetResponseToJSON,
} from '../models/index';

export interface GetAvailablePermissions1Request {
    page?: string;
    pageSize?: string;
    sessionId?: string;
}

export interface GetCreatableCaseTypesRequest {
    page?: string;
    pageSize?: string;
    sessionId?: string;
}

export interface GetFieldMappingRequest {
    resourceType: string;
    sessionId?: string;
}

export interface GetPermissionMetadataRequest {
    permission: string;
    sessionId?: string;
}

export interface GetPermissionsForOperationRequest {
    operation: string;
    page?: string;
    pageSize?: string;
    sessionId?: string;
}

export interface GetPermissionsForResourceTypeRequest {
    resourceType: string;
    page?: string;
    pageSize?: string;
    sessionId?: string;
}

export interface GetUserFieldPermissionsRequest {
    resourceType: string;
    action: string;
    page?: string;
    pageSize?: string;
    sessionId?: string;
}

export interface ValidateFieldPermissionsRequest {
    resourceType: string;
    action: string;
    requestBody: Set<string>;
    sessionId?: string;
}

/**
 * PermissionsApi - interface
 * 
 * @export
 * @interface PermissionsApiInterface
 */
export interface PermissionsApiInterface {
    /**
     * Retrieves paginated list of all available permissions in the system
     * @summary Get available permissions
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getAvailablePermissions1Raw(requestParameters: GetAvailablePermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSetResponse>>;

    /**
     * Retrieves paginated list of all available permissions in the system
     * Get available permissions
     */
    getAvailablePermissions1(requestParameters: GetAvailablePermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSetResponse>;

    /**
     * Retrieves paginated list of case types a user can create
     * @summary Get creatable case types
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getCreatableCaseTypesRaw(requestParameters: GetCreatableCaseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>>;

    /**
     * Retrieves paginated list of case types a user can create
     * Get creatable case types
     */
    getCreatableCaseTypes(requestParameters: GetCreatableCaseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse>;

    /**
     * Retrieves field mapping for a resource type
     * @summary Get field mapping
     * @param {string} resourceType Resource type
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getFieldMappingRaw(requestParameters: GetFieldMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>>;

    /**
     * Retrieves field mapping for a resource type
     * Get field mapping
     */
    getFieldMapping(requestParameters: GetFieldMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse>;

    /**
     * Retrieves metadata for a specific permission
     * @summary Get permission metadata
     * @param {string} permission Permission name
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getPermissionMetadataRaw(requestParameters: GetPermissionMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionMetadataResponse>>;

    /**
     * Retrieves metadata for a specific permission
     * Get permission metadata
     */
    getPermissionMetadata(requestParameters: GetPermissionMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionMetadataResponse>;

    /**
     * Retrieves paginated list of permissions for a specific operation
     * @summary Get permissions for operation
     * @param {string} operation Operation name
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getPermissionsForOperationRaw(requestParameters: GetPermissionsForOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSetResponse>>;

    /**
     * Retrieves paginated list of permissions for a specific operation
     * Get permissions for operation
     */
    getPermissionsForOperation(requestParameters: GetPermissionsForOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSetResponse>;

    /**
     * Retrieves paginated list of permissions for a specific resource type
     * @summary Get permissions for resource type
     * @param {string} resourceType Resource type
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getPermissionsForResourceTypeRaw(requestParameters: GetPermissionsForResourceTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSetResponse>>;

    /**
     * Retrieves paginated list of permissions for a specific resource type
     * Get permissions for resource type
     */
    getPermissionsForResourceType(requestParameters: GetPermissionsForResourceTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSetResponse>;

    /**
     * Retrieves paginated field-level permissions for a user
     * @summary Get user field permissions
     * @param {string} resourceType Resource type
     * @param {string} action Action
     * @param {string} [page] Page number
     * @param {string} [pageSize] Page size
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    getUserFieldPermissionsRaw(requestParameters: GetUserFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>>;

    /**
     * Retrieves paginated field-level permissions for a user
     * Get user field permissions
     */
    getUserFieldPermissions(requestParameters: GetUserFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse>;

    /**
     * Validates field-level permissions for a resource
     * @summary Check field permissions
     * @param {string} resourceType Resource type
     * @param {string} action Action
     * @param {Set<string>} requestBody 
     * @param {string} [sessionId] Session ID
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof PermissionsApiInterface
     */
    validateFieldPermissionsRaw(requestParameters: ValidateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>>;

    /**
     * Validates field-level permissions for a resource
     * Check field permissions
     */
    validateFieldPermissions(requestParameters: ValidateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse>;

}

/**
 * 
 */
export class PermissionsApi extends runtime.BaseAPI implements PermissionsApiInterface {

    /**
     * Retrieves paginated list of all available permissions in the system
     * Get available permissions
     */
    async getAvailablePermissions1Raw(requestParameters: GetAvailablePermissions1Request, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSetResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionSetResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of all available permissions in the system
     * Get available permissions
     */
    async getAvailablePermissions1(requestParameters: GetAvailablePermissions1Request = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSetResponse> {
        const response = await this.getAvailablePermissions1Raw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of case types a user can create
     * Get creatable case types
     */
    async getCreatableCaseTypesRaw(requestParameters: GetCreatableCaseTypesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions/case-types/creatable`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FieldPermissionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of case types a user can create
     * Get creatable case types
     */
    async getCreatableCaseTypes(requestParameters: GetCreatableCaseTypesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse> {
        const response = await this.getCreatableCaseTypesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves field mapping for a resource type
     * Get field mapping
     */
    async getFieldMappingRaw(requestParameters: GetFieldMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getFieldMapping().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions/field/mapping/{resourceType}`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FieldPermissionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves field mapping for a resource type
     * Get field mapping
     */
    async getFieldMapping(requestParameters: GetFieldMappingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse> {
        const response = await this.getFieldMappingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves metadata for a specific permission
     * Get permission metadata
     */
    async getPermissionMetadataRaw(requestParameters: GetPermissionMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionMetadataResponse>> {
        if (requestParameters['permission'] == null) {
            throw new runtime.RequiredError(
                'permission',
                'Required parameter "permission" was null or undefined when calling getPermissionMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions/{permission}/metadata`;
        urlPath = urlPath.replace(`{${"permission"}}`, encodeURIComponent(String(requestParameters['permission'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionMetadataResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves metadata for a specific permission
     * Get permission metadata
     */
    async getPermissionMetadata(requestParameters: GetPermissionMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionMetadataResponse> {
        const response = await this.getPermissionMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of permissions for a specific operation
     * Get permissions for operation
     */
    async getPermissionsForOperationRaw(requestParameters: GetPermissionsForOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSetResponse>> {
        if (requestParameters['operation'] == null) {
            throw new runtime.RequiredError(
                'operation',
                'Required parameter "operation" was null or undefined when calling getPermissionsForOperation().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions/operation/{operation}`;
        urlPath = urlPath.replace(`{${"operation"}}`, encodeURIComponent(String(requestParameters['operation'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionSetResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of permissions for a specific operation
     * Get permissions for operation
     */
    async getPermissionsForOperation(requestParameters: GetPermissionsForOperationRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSetResponse> {
        const response = await this.getPermissionsForOperationRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated list of permissions for a specific resource type
     * Get permissions for resource type
     */
    async getPermissionsForResourceTypeRaw(requestParameters: GetPermissionsForResourceTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PermissionSetResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getPermissionsForResourceType().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions/resource/{resourceType}`;
        urlPath = urlPath.replace(`{${"resourceType"}}`, encodeURIComponent(String(requestParameters['resourceType'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PermissionSetResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated list of permissions for a specific resource type
     * Get permissions for resource type
     */
    async getPermissionsForResourceType(requestParameters: GetPermissionsForResourceTypeRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PermissionSetResponse> {
        const response = await this.getPermissionsForResourceTypeRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Retrieves paginated field-level permissions for a user
     * Get user field permissions
     */
    async getUserFieldPermissionsRaw(requestParameters: GetUserFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling getUserFieldPermissions().'
            );
        }

        if (requestParameters['action'] == null) {
            throw new runtime.RequiredError(
                'action',
                'Required parameter "action" was null or undefined when calling getUserFieldPermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resourceType'] != null) {
            queryParameters['resourceType'] = requestParameters['resourceType'];
        }

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['pageSize'] = requestParameters['pageSize'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/v1/permissions/field/user`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FieldPermissionResponseFromJSON(jsonValue));
    }

    /**
     * Retrieves paginated field-level permissions for a user
     * Get user field permissions
     */
    async getUserFieldPermissions(requestParameters: GetUserFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse> {
        const response = await this.getUserFieldPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Validates field-level permissions for a resource
     * Check field permissions
     */
    async validateFieldPermissionsRaw(requestParameters: ValidateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FieldPermissionResponse>> {
        if (requestParameters['resourceType'] == null) {
            throw new runtime.RequiredError(
                'resourceType',
                'Required parameter "resourceType" was null or undefined when calling validateFieldPermissions().'
            );
        }

        if (requestParameters['action'] == null) {
            throw new runtime.RequiredError(
                'action',
                'Required parameter "action" was null or undefined when calling validateFieldPermissions().'
            );
        }

        if (requestParameters['requestBody'] == null) {
            throw new runtime.RequiredError(
                'requestBody',
                'Required parameter "requestBody" was null or undefined when calling validateFieldPermissions().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['resourceType'] != null) {
            queryParameters['resourceType'] = requestParameters['resourceType'];
        }

        if (requestParameters['action'] != null) {
            queryParameters['action'] = requestParameters['action'];
        }

        if (requestParameters['sessionId'] != null) {
            queryParameters['sessionId'] = requestParameters['sessionId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/v1/permissions/field/validate`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['requestBody'],
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FieldPermissionResponseFromJSON(jsonValue));
    }

    /**
     * Validates field-level permissions for a resource
     * Check field permissions
     */
    async validateFieldPermissions(requestParameters: ValidateFieldPermissionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FieldPermissionResponse> {
        const response = await this.validateFieldPermissionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
